import { Select, Tag } from 'antd';
import { TFieldRendererProps } from '@/types/TSmartCRM';
import { EFieldMode } from 'src/enums/ESmartCRM';

export const ArrayRenderer = ({
	field,
	value,
	onChange,
	mode,
	size,
	disabled = false,
	placeholder,
}: TFieldRendererProps) => {
	const arrayValue = Array.isArray(value) ? value : [];
	const options =
		field.options?.map((option) => ({
			label: option,
			value: option,
		})) || [];

	if (mode === EFieldMode.DISPLAY) {
		if (!arrayValue.length) {
			return <span>-</span>;
		}
		return (
			<div>
				{arrayValue.map((item, index) => (
					<Tag key={`${item}-${index}`} color="purple">
						{item}
					</Tag>
				))}
			</div>
		);
	}

	return (
		<Select
			mode="multiple"
			value={arrayValue.length === 0 ? undefined : arrayValue}
			onChange={onChange}
			options={options}
			size={size}
			disabled={disabled}
			placeholder={
				placeholder ||
				(mode === EFieldMode.FILTER ? 'Select options' : `Select ${field.fieldName.toLowerCase()}`)
			}
			allowClear
			showSearch
			optionFilterProp="label"
			className="w-full"
		/>
	);
};
